import p1 from './01.png';
import p2 from './dashboard_d_expanded.png';
import p3 from './dashboard_l_expanded.png';
import p4 from './details_D.png';
import p5 from './details_D_fule.png';
import p6 from './2.PNG';
import p8 from './3.PNG';
import p9 from './Capture4.PNG';
import p10 from './Capture5.PNG';
import p11 from './Capture6.PNG';
import p12 from './Capture7.PNG';
import p13 from './dmcn.PNG';
import p14 from './rntfch.PNG';
import p15 from './rntc.PNG';
import p16 from './pTab.PNG';
import p17 from './pass_reset.PNG';
import p18 from './login.PNG';
import p19 from './hsf.PNG';
import p20 from './fldc.PNG';
import p21 from './fldc.PNG';
import p22 from './fldc.PNG';
import p23 from './Feature controle.png';
import p24 from './dashboard_Table_expanded.png';
import p25 from './dashboard_d_Table_expanded.png';
import t_form from './t_form.PNG';
import t_table from './table.PNG';

export const galleries = [
  {
    title: '',
    image: t_table,
    icon: t_table,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: t_form,
    icon: t_form,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p1,
    icon: p1,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p2,
    icon: p2,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p3,
    icon: p3,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p4,
    icon: p4,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p5,
    icon: p5,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p6,
    icon: p6,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p8,
    icon: p8,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p9,
    icon: p9,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p10,
    icon: p10,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p11,
    icon: p11,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p12,
    icon: p12,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p13,
    icon: p13,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p14,
    icon: p14,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p15,
    icon: p15,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p16,
    icon: p16,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p17,
    icon: p17,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p18,
    icon: p18,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p19,
    icon: p19,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p20,
    icon: p20,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p21,
    icon: p21,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p22,
    icon: p22,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p23,
    icon: p23,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p24,
    icon: p24,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: p25,
    icon: p25,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
];
